/** CoStar.Api.ApartmentsApp.ViewModels.PreferenceType */
export var PreferenceType;
(function (PreferenceType) {
    PreferenceType[PreferenceType["Unknown"] = 0] = "Unknown";
    PreferenceType[PreferenceType["Locality"] = 1] = "Locality";
})(PreferenceType || (PreferenceType = {}));
/** CoStar.Api.ApartmentsApp.ViewModels.ListingPreferencesMatchType */
export var ListingPreferencesMatchType;
(function (ListingPreferencesMatchType) {
    ListingPreferencesMatchType[ListingPreferencesMatchType["Unknown"] = 0] = "Unknown";
    ListingPreferencesMatchType[ListingPreferencesMatchType["City"] = 3] = "City";
    ListingPreferencesMatchType[ListingPreferencesMatchType["Submarket"] = 5] = "Submarket";
    ListingPreferencesMatchType[ListingPreferencesMatchType["Cluster"] = 21] = "Cluster";
})(ListingPreferencesMatchType || (ListingPreferencesMatchType = {}));
